import {openDialog} from 'platform/components';

import type {ComponentProps} from 'react';

import i18n from '@dms/i18n';

import {PlatformPreflightDialog} from '../components/PlatformPreflightDialog';

type OpenPlatformPreflightDialogProps = ComponentProps<typeof PlatformPreflightDialog>;

export function openPlatformPreflightDialog(props: OpenPlatformPreflightDialogProps) {
  openDialog(<PlatformPreflightDialog {...props} />, {
    title: `${i18n.t('general.labels.blocked')} — ${props.platformTitle}`,
  });
}
